import { FieldValues, Path, UseFormRegister } from 'react-hook-form';

export const registerInput = <T extends FieldValues>(
  register: UseFormRegister<T>,
  fieldName: Path<T>
) => {
  const { ref, ...rest } = register(fieldName);
  return {
    ...rest,
    inputRef: register(fieldName).ref,
  };
};
